/**
 * Search results refine bar
 * @constructor
 */
define(['jquery', 'jqueryenter', 'jqueryeffects', 'c21textdropdown', 'c21minmaxdropdown', 'jqueryui', 'c21/modalWindow', 'c21/internationalization', 'c21/results', 'c21/track', 'c21/ajax', 'c21/cookie', 'c21/portal'], function () {
   "use strict";

   var $ = require('jquery'),
      results = require('c21/results'),
      portal = require('c21/portal'),
      modalWindow = require('c21/modalWindow'),
      internationalization = require('c21/internationalization'),
      track = require('c21/track'),
      ajax = require('c21/ajax'),
      cookie = require('c21/cookie');

   return function () {
      var self = this,

         m_jRefineSearch,
         m_schoolSearch,

         m_aPriceOptions = [
            "$10,000",
            "$20,000",
            "$30,000",
            "$50,000",
            "$75,000",
            "$100,000",
            "$125,000",
            "$150,000",
            "$175,000",
            "$200,000",
            "$225,000",
            "$250,000",
            "$300,000",
            "$350,000",
            "$400,000",
            "$450,000",
            "$500,000",
            "$600,000",
            "$700,000",
            "$800,000",
            "$1,000,000",
            "$1,250,000",
            "$1,500,000",
            "$1,750,000",
            "$2,000,000",
            "$2,500,000",
            "$3,000,000"
         ],

         m_aSizeOptions = [
            ["", "Any"],
            ["0-1", "<1"],
            ["1", "1+"],
            ["3", "3+"],
            ["5", "5+"],
            ["10", "10+"],
            ["20", "20+"],
            ["30", "30+"],
            ["40", "40+"],
            ["50", "50+"],
            ["100", "100+"],
            ["1000", "1000+"]
         ],

         m_aSquareFeetOptions = [
            ["", "Any"],
            ["1000", "1000+"],
            ["2000", "2000+"],
            ["3000", "3000+"],
            ["5000", "5000+"],
            ["7500", "7500+"],
            ["10000", "10000+"],
            ["12500", "12500+"],
            ["15000", "15000+"],
            ["20000", "20000+"],
            ["30000", "30000+"]
         ],

         m_aBedsBathsOptions = [
            ["", "Any"],
            ["1", "1+"],
            ["2", "2+"],
            ["3", "3+"],
            ["4", "4+"],
            ["5", "5+"]
         ];

      function initCheckboxList (jLabels, o) {
         jLabels.each(function () {
            var jLabel = $(this),
               strFor = jLabel.attr('for'),
               jInput,
               jSpan = jLabel.find('span'),
               jCheckbox = jLabel.find(".propOptionCheckbox");

            jLabel.addClass("initialized");

            if (jCheckbox.length > 0) {
               jCheckbox.uniform();
            }

            if (strFor) {
               jInput = jLabel.find('#' + strFor);
            } else {
               return;
            }

            if (jInput.length === 0) {
               return;
            }

            jLabel.addClass('c21hoverstate');
               
            jLabel.hover(function() {
               if (!jInput.attr("disabled") && !jSpan.hasClass("checked")) {
                  jLabel.addClass('hover');
               }
            }, function() {
               jLabel.removeClass('hover');
            });

            jCheckbox.on("change", function () {
               if (jInput.prop("checked")) {
                  if (o.check) {
                     o.check(jInput);
                  }

                  jInput.prop("checked", true);
               } else {
                  if (o.uncheck) {
                     o.uncheck(jInput);
                  }

                  jInput.prop("checked", false);
               }

               $.uniform.update(jInput.get(0));
            });
         });
      }

      function getFacetParts (jInput) {
         var strId = jInput.attr("id"),
           aParts = strId.split(/_(.+)?/),
           strFacet = aParts[0],
           strValue = aParts[1];

            return {
            facet: strFacet,
            value: strValue
         };
      }

      function initMoreSearchOptions (jContainer) {
         var jLabels = jContainer.find(".refineItem label:not(.initialized)");
         initCheckboxList(jLabels, {
            check: function (jInput) {
               var oParts = getFacetParts(jInput);
               results.addListFacet(oParts.facet, oParts.value);
            },
            uncheck: function (jInput) {
               var oParts = getFacetParts(jInput);
               if (jInput.hasClass('listParameter')) {
                  results.removeListFacet(oParts.facet, oParts.value);
               } else {
                  results.removeFacet(oParts.facet);
               }
            }
         });
      }

      function setPropertySearchCookie () {
         cookie.set("LAST_LOCATION", $("#lastLocationLID").val());
         cookie.set("LAST_SEARCH", $("#encodedSearch").val());
         cookie.set("LAST_PROPERTIES", $("#encodedSearch").val());
      }

      function initPropertyRefinement () {
         setPropertySearchCookie();

         // More Search Options
         $("#refineFeaturesLink, #refineFeaturesButton").click(function() {
            var searchUrl = '';
            var jBody = $('body');
            if( (jBody.hasClass("pageEco")) && (window.websiteCode === 'ECO_ESP') ) { // Eco (Spanish Enabled)
               searchUrl = '/searchoptions/';
            } else if ( (jBody.hasClass("pageEco")) || (jBody.hasClass("pageEcoIdx") && document.location.pathname === "/search/") ) { // Eco or IDX (My/Our Listings)
               searchUrl = '/searchoptions/';
            } else if(jBody.hasClass('pageEcoIdx')) { // IDX (Location Search)
               searchUrl = "/searchoptions/idx/";
            }

            if(searchUrl !== '') {
               $.get(searchUrl, ajax.getParameters(), function (data) {
                  modalWindow.modal('More Search Options', {
                     body: data[0].html,
                     size: 'lg'
                  });
               });
            }
         });

         var bSomethingChanged = false,

            jBedrooms = $("#lqbedrooms"),
            jBathrooms = $("#lqbathrooms"),
            jStructureSize = $("#lqstructureSize"),
            jLotSize = $("#lqlotSize"),
            jC21MinMaxDropdown = jBedrooms
               .add(jBathrooms)
               .add(jStructureSize)
               .add(jLotSize),

            jPriceFrom = $("#lqMinPriceHidden"),
            jPriceTo = $("#lqMaxPriceHidden"),
            jSaleFrom = $("#lqsalepriceFrom"),
            jSaleTo = $("#lqsalepriceTo"),
            jLeaseFrom = $("#lqleasepriceFrom"),
            jLeaseTo = $("#lqleasepriceTo"),
            jC21TextDropdown = jPriceFrom
               .add(jPriceTo)
               .add(jSaleFrom)
               .add(jSaleTo)
               .add(jLeaseFrom)
               .add(jLeaseTo),

            onBlurAndChange = function () {
               bSomethingChanged = true;
            },

            // NOTE: Fires after onBlurAndChange
            onBlur = function () {
               if (!bSomethingChanged) {
                  return;
               }

               // Wait a second!
               setTimeout(function () {
                  // Check if any dropdowns are showing
                  var bShowing = false;

                  $.each(jC21TextDropdown, function (i, elCombo) {
                     var jCombo = $(elCombo);
                     if (!jCombo.c21textdropdown('hidden')) {
                        bShowing = true;
                        return false;
                     }
                  });

                  $.each(jC21MinMaxDropdown, function (i, elCombo) {
                     var jCombo = $(elCombo);
                     if (!jCombo.c21minmaxdropdown('hidden')) {
                        bShowing = true;
                        return false;
                     }
                  });

                  // If so, the user PROBABLY doesn't want to submit the search
                  // quite yet!!!
                  if (bShowing) {
                     return;
                  }

                  // Ok maybe the user does
                  results.updateLiquidFacets();
               }, 1000);
            },

            addPrice = function (aOptions, jFrom, jTo) {
               var oDefaults = {
                     type: "combo",
                     maxLength: 10,
                     onBlurAndChange: onBlurAndChange,
                     onBlur: onBlur,
                     dropdownClass: 'lqPriceDropdown',
                     inputClass: 'lqShortSelectBox',
                     parentNode: m_jRefineSearch,
                     translate: internationalization.getString
                  };

               jFrom.c21textdropdown(aOptions, $.extend({}, oDefaults, {
                  tabIndex: iTabIndex++,
                  textHint: 'Min'
               }));

               jTo.c21textdropdown(aOptions, $.extend({}, oDefaults, {
                  tabIndex: iTabIndex++,
                  textHint: 'Max'
               }));
            },

            addMinMaxDropdown = function (aOptions, jElem, options) {
               jElem.c21minmaxdropdown(aOptions, $.extend({}, {
                  tabIndex: (iTabIndex += 2),
                  onBlurAndChange: onBlurAndChange,
                  onBlur: onBlur,
                  dropdownClass: 'lqLongDropdown',
                  translate: internationalization.getString,
                  textHint: 'Any'
               }, options));
            };

         var iTabIndex = 100;
         addPrice(m_aPriceOptions, jPriceFrom, jPriceTo);
         addPrice(m_aPriceOptions, jSaleFrom, jSaleTo);
         addPrice(m_aPriceOptions, jLeaseFrom, jLeaseTo);

         // begin c21minmaxdropdown
         iTabIndex = 390;
         addMinMaxDropdown(m_aBedsBathsOptions, jBedrooms, {
            maxLength: 7,
            selectBoxClass: 'lqSelectBox lqShortSelectBox',
            baseName: 'lqbedrooms'
         });

         addMinMaxDropdown(m_aBedsBathsOptions, jBathrooms, {
            maxLength: 2,
            selectBoxClass: 'lqSelectBox lqShortSelectBox',
            baseName: 'lqbathrooms'
         });

         addMinMaxDropdown(m_aSquareFeetOptions, jStructureSize, {
            maxLength: 7,
            selectBoxClass: 'lqSelectBox lqLongSelectBox',
            baseName: 'lqstructureSize'
         });

         addMinMaxDropdown(m_aSizeOptions, jLotSize, {
            maxLength: 7,
            selectBoxClass: 'lqSelectBox lqLongSelectBox',
            baseName: 'lqlotSize'
         });
         // end c21minmaxdropdown

         initMoreSearchOptions($("#morePropSearchOptionsSection"));
         initMoreSearchOptions($("#commercialPropertyTypes"));

         m_jRefineSearch.find("input:visible").focus(function () {
            $(document).trigger("hideDropdowns");
         });

         responsiveLeftRail();
         setTimeout(responsiveLeftRail, 200);
      }

      // Responsive left rail
      function responsiveLeftRail () {
         var jSearchOptions = $("#morePropSearchOptionsSection"),
            jRefineFeatures = $("#refineFeaturesButton").hide();

         // Sometimes this will not be on the page
         // EX: if there are no refinements with any results
         if (jSearchOptions.length === 0) return;
         
         // Show so we can make accurate measurements with JS
         jSearchOptions.show();

         var jBodyLeftLane = $("#BodyLeftLane"),
            iLaneHeight = jBodyLeftLane.height(),

            jContainer = jSearchOptions.find(".searchOptions"),
            iSearchOptionsTop = jContainer.position().top,

            jRefineLink = $("#refineFeaturesLink").show(),
            iRefineHeight = jRefineLink.outerHeight(),

            iSpaceAvailable = iLaneHeight - iSearchOptionsTop - iRefineHeight,
            iCurrentTop = 0,

            jAllOrNothing,
            bLastRefineSection = false;

         // For all of the refinement groups
         jAllOrNothing = jSearchOptions.find('.allOrNothing');
         jAllOrNothing.each(function (i) {
            var jThis = $(this),
               iHeight;

            // We've already hit the last visible refine section
            // Don't bother with math. Just hide the section.
            if (bLastRefineSection) {
               jThis.addClass('hideAllOrNothing');
            } else {
               jThis.removeClass('hideAllOrNothing');

               // Math!
               iHeight = jThis.outerHeight();
               iCurrentTop += iHeight;

               if (iCurrentTop < iSpaceAvailable) {
                  jThis.removeClass('hideAllOrNothing');
               } else {
                  jThis.addClass('hideAllOrNothing');

                  // Flag as having hit the last refine section
                  bLastRefineSection = true;

                  // NONE are showing?
                  if (i === 0) {
                     // Hide the whole thing
                     jSearchOptions.hide();

                     // Show the "More Search Options" button
                     // (not to be confused with the link)
                     jRefineFeatures.show();

                     // Don't loop any more
                     return false;
                  } else if (i === jAllOrNothing.length) {
                     // "View All Options" isn't very useful if there
                     // is nothing more to refine the search by...
                     jRefineLink.hide();
                  }
               }
            }
         });
      }

      function initRefinement () {
         portal.setMainSearchText();

         // Clear All
         $(".LiquidBody #clearAll").click(function(e) {
            e.preventDefault();
            results.clearLiquidMapFacets();
         });

         // Show/Hide Clear All Link
         if ($(".removeFacet, .removeListFacet").length > 1) {
            $(".LiquidBody #clearAll").show();
         } else {
            $(".LiquidBody #clearAll").hide();
         }

         var jCurrentSearch = $("#currentSearch"),

            jCurrentSrBox = $("#currentSrBox"),
            jLaneTitle = jCurrentSrBox.find(".LaneTitle"),
            jLaneText = jCurrentSearch.find(".LaneText"),
            jSlider = $("#currentSearchSlider"),

            iMaxHeight = 100,
            iPadding = 10,
            iHeight = jLaneText.height() + (iPadding * 2),
            bTooTall = iHeight > iMaxHeight,
            iTitleHeight = jLaneTitle.height(),
            iCollapseHeight = iMaxHeight + iTitleHeight,
            iExpandHeight = iHeight + iTitleHeight,
            bAlreadyTriggered = false;

         jSlider.toggle(bTooTall);
         jCurrentSrBox.off(".initRefinement").css('height', '');

         function preventRetrigger () {
            bAlreadyTriggered = true;
            setTimeout(function () { bAlreadyTriggered = false; }, 500);
         }

         function toggleHeight () {
            if (jCurrentSrBox.hasClass("expanded")) {
               jCurrentSrBox.trigger("mouseleave.initRefinement");
            } else {
               jCurrentSrBox.trigger("mouseenter.initRefinement");
            }
         }

         jSlider.click(toggleHeight);

         if (bTooTall) {
            // Start collapsed
            jCurrentSrBox.css({
               height: iCollapseHeight
            });

            jCurrentSrBox.on({
               "touchstart.initRefinement": function (e) {
                  if ($(e.target).prop("tagName") === "A") {
                     return;
                  }

                  toggleHeight();
                  preventRetrigger();
               },

               "click.initRefinement": function (e) {
                  if ($(e.target).prop("tagName") === "A") {
                     return;
                  }

                  toggleHeight();
               },

               "mouseenter.initRefinement": function () {
                  if (bAlreadyTriggered) {
                     return;
                  }

                  jCurrentSrBox.stop(true).animate({
                     height: iExpandHeight
                  }).addClass("expanded");

                  jCurrentSearch.css({
                     maxHeight: 99999
                  });

                  // Update the school search banner ad bug position & modal tool tip position
                  // FIXME: Update the surrounding area tooltip position using this trigger
                  var iHeightDiff = iExpandHeight - iCollapseHeight;
                  $(window).trigger("refinesizechanged", {
                     heightDiff: iHeightDiff
                  });
               },

               "mouseleave.initRefinement": function () {
                  if (bAlreadyTriggered) {
                     return;
                  }

                  jCurrentSrBox.stop(true).animate({
                     height: iCollapseHeight
                  }).removeClass("expanded");
               }
            });
         }

         jCurrentSearch.find(".removeFacet").click(function () {
            var jThis = $(this),
               strFacet = jThis.data("facet");

            results.removeFacet(strFacet);
         });

         jCurrentSearch.find(".removeListFacet").each(function () {
            var jThis = $(this),
               strValue = jThis.data("listfacet-value"),
               strKey = jThis.data("listfacet-key"),
               strId = ["#", strValue, "_", strKey].join(""),
               jFacetCheckbox = $(strId);

            jThis.click(function () {
               results.removeListFacet(strValue, strKey);
            });

            if (jFacetCheckbox.length > 0) {
               jFacetCheckbox.prop("checked", true);
               $.uniform.update(jFacetCheckbox.get(0));
            }
         });

         jCurrentSearch.find(".removeSchool").click(function () {
            var jThis = $(this),
               strSchool = jThis.data("school");

            track.doEvent('Schools', 'Mapping Page', 'Remove selected school');
            m_schoolSearch.removeSchool(strSchool);
         });

         var jLocationText = $("#refineText"),
            jKeywordText = $("#keywordText"),
            jMlsText = $("#mlsSearch"),

            refineMls = function () {
               results.changeMls(jMlsText);
            },

            refineLocation = function () {
               results.changeSearchLocation(jLocationText);
            },

            refineKeywords = function () {
               results.changeKeywords(jKeywordText);
            };

         $("#locationUpdateButton").click(refineLocation);
         jLocationText.enter(refineLocation);

         $("#keywordUpdateButton").click(refineKeywords);
         jKeywordText.enter(refineKeywords);

         $("#mlsUpdateButton").click(refineMls);
         jMlsText.enter(refineMls);

         initPropertyRefinement();
      }

      function onDocumentReady () {
         m_jRefineSearch = $("#refineSearch");
         ajax.bindLoadEvent(m_jRefineSearch, initRefinement);
      }

      function initialize (schoolSearch) {
         m_schoolSearch = schoolSearch;
         $(document).ready(onDocumentReady);
         $(window).resize(responsiveLeftRail);
      }

      self.initialize = initialize;
   };
});
